
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const Ticket = () => {
    const auth = useSelector((state) => state.AuthReducer);
    const [ticketData, setTicketData] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [loading, setLoading] = useState(false);

    const fetchTicket = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('accessToken');

            const res = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/user-all-tickets`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setTicketData(res.data?.tickets || []);
        } catch (error) {
            console.error('Error fetching tickets:', error);
            toast.error('Failed to load tickets.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTicket();
    }, []);

    if (!auth) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="spinner"></div>
            </div>
        );
    }

    const displayedTickets = showAll ? ticketData : ticketData.slice(0, 3);

    return (
        <React.Fragment>
            <form>
                <figure className='border shadow-lg'>
                    <div className='px-5 py-4 space-y-1 border-b' style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                        <span>
                            <h1 className='text-base font-medium'>Support Tickets</h1>
                            <p className='text-xs text-gray-500'>View and manage your support requests</p>
                        </span>
                        <Link to="/dashboard/ticket/create-ticket" className="btn-primary-sm">
                            Create Ticket
                        </Link>
                    </div>
                    {loading ? (
                        <div style={{ height: "25vh", display: "flex", alignItems: "center" }}>
                            <div className="spinner"></div>

                        </div>
                    ) : (
                        <div className="bg-gray-50 rounded-lg shadow-md mx-auto p-2">
                            {ticketData.length === 0 ? (
                                <div className="text-center text-gray-600 py-10">
                                    <h2 className="text-lg font-semibold">No Tickets Found</h2>
                                    <p className="text-sm text-gray-500">You haven’t submitted any support requests yet.</p>
                                    <Link to="/dashboard/ticket/create-ticket" className="btn-primary-sm mt-4 inline-block">
                                        Create Your First Ticket
                                    </Link>
                                </div>
                            ) : (
                                <>
                                    {displayedTickets.map((data) => (
                                        <li key={data.id} className="bg-white border border-gray-200 mt-5 p-2 rounded-lg shadow-sm hover:shadow-lg transition-shadow duration-300 mb-4 list-none">
                                            <div className="flex justify-between items-center ">
                                                <div>
                                                    <p className="text-lg font-semibold">Ticket ID: {data.id}</p>
                                                    <p className="text-sm">{data.title || "Title not found"}</p>
                                                </div>
                                                <span
                                                    className={`inline-block text-xs font-semibold px-3 py-1 rounded-full
                                ${data.status === 'open' ? 'bg-blue-100 text-blue-800' :
                                                            data.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                                                                data.status === 'closed' ? 'bg-red-100 text-red-800' :
                                                                    'bg-gray-100 text-gray-800'}`}
                                                >
                                                    {data.status}
                                                </span>
                                            </div>
                                            <p className="text-base text-gray-700">
                                                {data.message}
                                            </p>
                                            <Link
                                                to={`/dashboard/ticket/ticket-details/${data.id}`}
                                                className='btn-primary-sm mt-2 inline-block'
                                            >
                                                View Details
                                            </Link>
                                        </li>
                                    ))}
                                    {ticketData.length > 3 && (
                                        <div className="text-center mt-4">
                                            <button
                                                type="button"
                                                onClick={() => setShowAll(!showAll)}
                                                className="text-blue-600 hover:underline text-sm"
                                            >
                                                {showAll ? 'Show Less' : 'See All'}
                                            </button>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </figure>
            </form>
        </React.Fragment>
    );
};

export default Ticket;
